module.exports = __webpack_public_path__ + "img/horizontal-orientatio-icon.ac6eb3c.svg";